import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  isAnalyticsCollectionEnabled,
  subscribeAnalyticsPreferenceChange,
  trackPageView,
} from '../lib/analytics';
import { useApp } from '../context/AppContext';

export const useAnalytics = () => {
  const location = useLocation();
  const { user } = useApp();
  const prevLocationRef = useRef<string | null>(null);

  const firePageViewForPath = useCallback(
    (path: string) => {
      if (!isAnalyticsCollectionEnabled()) return;
      prevLocationRef.current = path;
      trackPageView(path, user);
    },
    [user],
  );

  useEffect(() => {
    const path = location.pathname;
    if (prevLocationRef.current === path) return;
    firePageViewForPath(path);
  }, [location.pathname, firePageViewForPath]);

  useEffect(() => {
    return subscribeAnalyticsPreferenceChange(() => {
      if (!isAnalyticsCollectionEnabled()) return;
      const path = location.pathname;
      prevLocationRef.current = path;
      trackPageView(path, user);
    });
  }, [location.pathname, user]);
};
